import React from "react";
import { Form } from "react-bootstrap";
import { FieldValidation } from "../useCreateWizard";

interface ValidatedSelectProps extends Omit<React.ComponentProps<typeof Form.Select>, "isInvalid" | "isValid"> {
    validation?: FieldValidation;
}

export const ValidatedSelect: React.FC<ValidatedSelectProps> = ({ validation, children, ...props }) => {
    const hasError = validation && !validation.isValid && validation.errorMessage;

    return (
        <Form.Select {...props} isInvalid={!!hasError}>
            {children}
        </Form.Select>
    );
};
